export let blockMapping = new Map<string, () => any>();

const registerBlock = (category: string, type: string) => {
  const importer = () => require(`@/views/cms/${category}/${type}`);
  blockMapping.set(`${type}Dto`, importer);
};

registerBlock('simple', 'TextBlock');
registerBlock('simple', 'HeadingBlock');
registerBlock('simple', 'ButtonBlock');
registerBlock('cmsref', 'ImageBlock');
registerBlock('cmsref', 'FormBlock');
registerBlock('cmsref', 'ContactBlock');
registerBlock('cmsref', 'AllContactsBlock');
registerBlock('cmsref', 'FeatureBlockGroup');
registerBlock('cmsref', 'EventBlock');
registerBlock('cmsref', 'FutureEventsBlock');
registerBlock('cmsref', 'ImageTileGroupBlock');
registerBlock('cmsref', 'PageRefBlock');
registerBlock('cmsref', 'YouTubeBlock');
registerBlock('structural', 'MultiColumnBlock');
registerBlock('productref', 'ProductsBlock');
registerBlock('productref', 'BigProductsBlock');
